// SidebarListItem.js
import React from 'react'
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { commonTheme } from '../../materialui/theme'

const ListItemContent = React.memo(function ({
  item,
  classes,
  isActive,
  onLogout,
  isCase
}) {
  // active かどうかは親から渡されてもいいですが、必要ならここで判定できます
  const color = isActive
    ? commonTheme.palette.secondary.main
    : commonTheme.palette.primary.light

  return (
    <ListItem button className={classes.button}>
      <ListItemIcon style={{ color }}>
        {item.icon}
      </ListItemIcon>
      <ListItemText
        primary={<span className={isCase ? classes.caseText : ''}>{item.name}</span>}
        secondary={item.secondary}
        className={`${classes.text}${isActive ? ` ${classes.nowButtonText}` : ''}`}
      />
    </ListItem>
  )
})

export default ListItemContent
